import BuildingType from '@/roc/building/BuildingType';
import BuildingMaxLevel from '@/roc/building/BuildingMaxLevel';
import Effects from '@/roc/effects/Effects';
import Happiness from '@/roc/effects/CultureBonus/Happiness';

const CavalryBarracks = {
  id: '9',
  name: 'Cavalry Barracks',
  width: 4,
  height: 5,
  type: BuildingType.BARRACKS,
  era: 'bronzeAge',
  icon: 'Cavalry',
  minLevel: 2,
  maxLevel: BuildingMaxLevel.ONE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Barracks/Cavalry_Barracks',
  flags: 0,
  counts: {
    stoneAge: null,
    bronzeAge: 1,
    minoanEra: 1,
    classicGreece: 1,
    earlyRome: 1,
    romanEmpire: 1,
    byzantineEra: 1,
    ageOfTheFranks: 1,
    feudalAge: 1,
    iberianEra: 1,
    kingdomOfSicily: 1,
    highMiddleAges: 1,
    earlyGothicEra: 1,
    lateGothicEra: 1,
  },
  effects: Effects.create([
    new Happiness({
      stoneAge: null,
      bronzeAge: [180, 360, 720],
      minoanEra: [240, 480, 960],
      classicGreece: [320, 640, 1280],
      earlyRome: [400, 800, 1600],
      romanEmpire: [480, 960, 1920],
      byzantineEra: [560, 1120, 2240],
      ageOfTheFranks: [680, 1360, 2720],
      feudalAge: [800, 1600, 3200],
      iberianEra: [960, 1920, 3840],
      kingdomOfSicily: [1160, 2320, 4640],
      highMiddleAges: [1400, 2800, 5600],
      earlyGothicEra: [1680, 3360, 6720],
      lateGothicEra: [2000, 4000, 8000],
    })
  ]),
};

export default CavalryBarracks;
